<form class="lv-artefact-container lv-component">
  <div class="lv-artefact Breite_Maximal">
    <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                      [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                      [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                      (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
    <div class="lv-flex" [ngClass]="uiArtefakt.BreiteInPixel">
      <mat-form-field class="lv-day-input-field">
        <div class="lv-input-field">
          <input matInput type="text" [disabled]="true" [value]="getFixedDay()" [placeholder]="'Tag'">
        </div>
      </mat-form-field>
      <mat-form-field class="lv-month-input-field" hideRequiredMarker>
        <div class="lv-input-field" [ngClass]="{'lv-error-state': !!getError() && !getYearError() || !!getMonthError()}">
          <input matInput lvMonthValidator type="text" [placeholder]="'Monat'" [required]="uiArtefakt.PflichtfeldJN"
                 [name]="uiArtefakt.Identifikator + '_Monat'" [disabled]="isDisabled"
                 [ngModel]="monthModel" (ngModelChange)="updateMonth($event)" [matAutocomplete]="autoMonth" (blur)="onMonthBlur()"
                 (focus)="hasMonthFocus = true" #monthinputmodel="ngModel">
        </div>
        <mat-autocomplete [hideSingleSelectionIndicator]="true" autoActiveFirstOption #autoMonth="matAutocomplete"
                          (optionSelected)="setMonthValue($event.option.value)" [panelWidth]="'fit-content'">
          <mat-option *ngFor="let option of getOptionsMonth()" [value]="option.index">
            {{option.index + ' ' + option.name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="lv-year-input-field" hideRequiredMarker>
        <div class="lv-input-field" [ngClass]="{'lv-error-state': !!getError() && !getMonthError() || !!getYearError()}">
          <input matInput lvYearValidator type="text" [placeholder]="'Jahr'" [required]="uiArtefakt.PflichtfeldJN"
                 [name]="uiArtefakt.Identifikator + '_Jahr'" [disabled]="isDisabled"
                 [ngModel]="yearModel" (ngModelChange)="updateYear($event)" [matAutocomplete]="autoYear" (blur)="onYearBlur()"
                 (focus)="hasYearFocus = true" #yearinputmodel="ngModel">
        </div>
        <mat-autocomplete [hideSingleSelectionIndicator]="true" autoActiveFirstOption #autoYear="matAutocomplete"
                          (optionSelected)="setYearValue($event.option.value)" [panelWidth]="'fit-content'">
          <mat-option *ngFor="let option of getOptionsYear()" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="lv-date-fixed-error-meldung-style">
      <div class="lv-date-fixed-error-meldung-text" [ngClass]="uiArtefakt.BreiteInPixel">
    <mat-error *ngIf="getTotalError() as error" class="lv-control-error"
               [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}" (click)="onErrorClick()">
      {{error}}
    </mat-error>
      </div>
    </div>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>
</form>
